import { Environment } from './environment.type';

export const environment: Environment = {
    development: true,
    production: true
};
